import React from "react";
import { useTranslation } from "react-i18next";

import {
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Radio,
  Typography,
  makeStyles
} from "@material-ui/core";

import { DriveEta as DriveEtaIcon } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  }
}));

const VehicleTrailerEditorSelectList = ({
  trailers,
  isLoading,
  onDeselect,
  onSelect
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={classes.center}>
        <CircularProgress />
      </div>
    );
  }

  if (trailers.length === 0) {
    return (
      <div className={classes.center}>
        <Typography color="textSecondary">
          {t("webapp:common.title.noTrailerFound")}
        </Typography>
      </div>
    );
  }

  return (
    <List>
      {trailers.map(({
        id,
        manufacturer,
        model,
        licensePlate,
        isSelected
      }) => {
        const handleChange = () => {
          if (isSelected) {
            onDeselect();
          } else {
            onSelect(id);
          }
        };

        return (
          <ListItem button key={id} onClick={handleChange}>
            <ListItemIcon>
              <DriveEtaIcon />
            </ListItemIcon>
            <ListItemText
              primary={`${manufacturer} ${model}`}
              secondary={licensePlate}
            />
            <ListItemSecondaryAction>
              <Radio
                color="primary"
                checked={isSelected}
                edge="end"
                onClick={handleChange}
              />
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );
};

export default VehicleTrailerEditorSelectList;
